<template>
    <BasePanel
        v-model="enabled"
        title="Taxas"
        @closePanel="$emit('closePanel')">
        <span v-if="onlyOneTax" slot="label">Gorjeta - {{ taxPercentage }}%</span>
        <div>
            <vs-divider/>
            <div class="mt-1 flex justify-between">
                Total em taxas:
                <b>{{ bill.value / taxPercentage | currency }}</b>
            </div>
        </div>
    </BasePanel>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
    import BasePanel from './BasePanel';
    export default {
        components: {
            BasePanel,
        },
        props: {
            value:  Boolean,
            totalValue: Number,
            bill: Object
        },
        data() {
            return {
                onlyOneTax: true // todo: handle multiple tax types
            }
        },
        computed: {
            enabled: {
                get () {
                    this.togglePayingTaxes(this.value);
                    return this.value;
                },
                set (v) {
                    this.togglePayingTaxes(v);
                    this.$emit('input', v);
                }
            },
            taxPercentage () {
                return this.bill?.taxes.percentage.value ?? 10;
            },
            ...mapState('payment', ['taxes'])
        },
        methods: mapMutations('payment', ['togglePayingTaxes']),
        mounted () {
            this.enabled = this.bill?.taxes.percentage.enabled;
        },
    }
</script>

<style lang="scss" scoped>

</style>